import { GetRentalConfigurationType as ApiGetRentalConfigurationType } from 'src/api/generated/touring/types';
import { mapMoneyType } from '../common';
import { VenueRentalConfigurationType } from './types';

export const mapVenueRentalConfigurationType = (
  apiType: ApiGetRentalConfigurationType
): VenueRentalConfigurationType => {
  return {
    id: apiType.id,
    validFrom: apiType.validFrom,
    validUntil: apiType.validUntil ?? null,
    configuration: apiType.configuration,
    version: apiType.version ?? null,
    capacity: apiType.capacity,
    rentalPercentageNet: apiType.rentalPercentageNet,
    rentalPercentageGross: apiType.rentalPercentageGross,
    rentalFlatFee: apiType.rentalFlatFee
      ? mapMoneyType(apiType.rentalFlatFee)
      : null,
    minimumRental: apiType.minimumRental
      ? mapMoneyType(apiType.minimumRental)
      : null,
    maximumRental: apiType.maximumRental
      ? mapMoneyType(apiType.maximumRental)
      : null,
    fixedVenueSideCosts: apiType.fixedVenueSideCosts
      ? mapMoneyType(apiType.fixedVenueSideCosts)
      : null,
    rentalSharePerTicket: apiType.rentalSharePerTicket
      ? mapMoneyType(apiType.rentalSharePerTicket)
      : null,
    rentalShareBasis: apiType.rentalShareBasis,
    notes: apiType.notes,
    archived: apiType.archived,
  };
};
